const settings = {
  initalCards: {
    top: 3,
    flop: 3,
    job: 4,
  },
  redrawCards: {
    top: 1,
    flop: 1,
    job: 2,
  },
}

export { settings }
